import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { HorseshoeIcon } from './HorseshoeIcon';
import { useLanguage } from '../contexts/LanguageContext';
import { stable } from '../data/stable';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-bark text-straw" data-id="element-114" data-mp="36p6c8wxiaub5">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-2 lg:px-8" data-id="element-115" data-mp="36pzb7bq84fiq">
        <div data-id="element-116" data-mp="3ugbs3c3g5mlg">
          <p className="flex items-center gap-2 font-serif text-2xl font-bold text-cream" data-id="element-117" data-mp="3ufjvbxy45itl">
            <HorseshoeIcon className="h-9 w-9 text-hay" data-id="element-118" data-mp="387czflhuzc3" />
            {stable.name}
          </p>
          <p className="mt-3 max-w-sm text-straw/80" data-id="element-119" data-mp="3ldkgncakmqtt">{t.footer.tagline}</p>
        </div>
        <div data-id="element-120" data-mp="3qcduj5trsjui">
          <h2 className="font-serif text-lg font-bold text-cream" data-id="element-121" data-mp="3qbvm7atu2f68">{t.footer.contact}</h2>
          <ul className="mt-3 space-y-2" data-id="element-122" data-mp="29ydvry6nv08u">
            <li className="flex items-center gap-2" data-id="element-123" data-mp="2a1jk3b7gty3i">
              <PhoneIcon className="h-4 w-4 text-hay" aria-hidden="true" data-id="element-124" data-mp="2ez1l8ff8r90y" />
              <a href={`tel:${stable.phone.replace(/\s/g, '')}`} className="hover:text-cream" data-id="element-125" data-mp="3l90pe0juz71d">{stable.phone}</a>
            </li>
            <li className="flex items-center gap-2" data-id="element-126" data-mp="3gbqy0fcwslaw">
              <MailIcon className="h-4 w-4 text-hay" aria-hidden="true" data-id="element-127" data-mp="3v7gfc075ga9a" />
              <a href={`mailto:${stable.email}`} className="hover:text-cream" data-id="element-128" data-mp="3v5n6ce92ddy4">{stable.email}</a>
            </li>
            <li className="flex items-start gap-2" data-id="element-129" data-mp="830jvkr3s91j">
              <MapPinIcon className="mt-1 h-4 w-4 shrink-0 text-hay" aria-hidden="true" data-id="element-130" data-mp="81pexhlx8v8u" />
              <a href={stable.mapUrl} target="_blank" rel="noopener noreferrer" className="underline-offset-4 hover:text-cream hover:underline" data-id="element-131" data-mp="32w3duq73ebb">
                {stable.address}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-straw/15" data-id="element-132" data-mp="cw3617tjwg7p">
        <p className="mx-auto max-w-7xl px-5 py-5 text-sm text-straw/60 lg:px-8" data-id="element-133" data-mp="qujkjkxnnb0e">
          © {new Date().getFullYear()} {stable.name}. {t.footer.rights}
        </p>
      </div>
    </footer>;
}